import { FC, useEffect, useState } from 'react';
import { ModalComponent } from 'components/Modal';
import { LoginCTA } from 'screens/Checkout/Form/LoginCTA';
import { CandidateType } from '../Candidates/Candidates';
import { ENV_CONFIG } from 'config/environment';
import { ContributionRules } from '../ContributionRules';
import { IPage } from 'store/donatePage/types';
import { IEvent } from 'store/eventPage/types';
import { PledgeDonateButtons } from '../AmountDetails/PledgeDonateButtons';
import { getShowAllDonateMethods, getUrlParams } from 'helpers/utils';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedDonationAmount: string;
  candidates: CandidateType[];
  isClientPremium: boolean;
  isDafEnabled: boolean;
  isWireEnabled?: boolean;
  onDonateButtonClick: () => void;
  onDafDonateClick: () => void;
  getOnDonateButtonClick: (method: string, type: string) => () => void;
  page: IPage | IEvent;
}

export const CompleteDonationModal: FC<Props> = ({
  isOpen,
  setIsOpen,
  selectedDonationAmount,
  candidates,
  isClientPremium,
  isWireEnabled,
  onDonateButtonClick,
  onDafDonateClick,
  getOnDonateButtonClick,
  page,
}) => {
  const { urlDonateMethod } = getUrlParams();
  const [isDafVisible, setIsDafVisible] = useState(false);

  useEffect(() => {
    const selectedCandidates = candidates.filter(c => c.isSelected);
    const updatedIsDafVisible =
      isClientPremium &&
      selectedCandidates.length === 1 &&
      !!selectedCandidates[0].misc_ids?.chariot_connect_id;
    setIsDafVisible(updatedIsDafVisible);
  }, [candidates, isClientPremium]);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      closeModal={handleCloseModal}
      contentLabel="Complete donation modal"
    >
      <div className="complete-donation-column">
        <span className="h4-text">Your donation summary</span>
        <span className="body-text">
          <span className="semi-bold">{selectedDonationAmount}</span> Total contribution amount
        </span>
        <span className="body-text">
          <span className="semi-bold">{candidates.filter(c => c.isSelected).length}</span>{' '}
          Recipients selected
        </span>
        <div className="line-divider" />
        <div className="content">
          <span className="eyebrow-text color-inkBlue">Donation Checkout</span>
          <LoginCTA candidates={candidates.filter(c => c.isSelected)} />
          <div className="buttons-container">
            <button
              type="button"
              className="button-brand donate-button"
              onClick={onDonateButtonClick}
            >
              donate with credit card / ACH
            </button>
            <PledgeDonateButtons
              isWireEnabled={isWireEnabled}
              isRecurring={false}
              showAllDonateMethods={getShowAllDonateMethods(urlDonateMethod)}
              donateMethod={urlDonateMethod}
              page={page}
              getOnDonateButtonClick={getOnDonateButtonClick}
            />
            {isDafVisible && (
              <div className="row justify-around">
                <button
                  type="button"
                  className="button-brand donate-button button-brand-daf split-screen"
                  onClick={onDafDonateClick}
                >
                  Continue with{' '}
                  <img
                    src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/daf_logo.png`}
                    alt="DAF Logo"
                  />
                </button>
              </div>
            )}
          </div>
          <ContributionRules />
        </div>
      </div>
    </ModalComponent>
  );
};
